import React, { useState, useEffect } from "react";
import { TaskHeadings1 } from "../../Data/Booking/DriverDetails";
import { Card, CardBody, Row } from "reactstrap";
import { P, Image } from "../../AbstractElements";
import { getAvatarText } from "../../Services/Shared.service";
const DriverInformation = ({ driverDetails }) => {
  const [profileImage, setProfileImage] = useState("");
  useEffect(() => {
    const letter = getAvatarText(driverDetails?.fullName);
    console.log(letter, "letter");
    setProfileImage(letter);
  }, [driverDetails]);
  const tableData = TaskHeadings1.map((element, i) => {
    let value = driverDetails[element.value]
      ? driverDetails[element.value]
      : "-";
    if (element.value == "type" && "isPrimaryDriver" in driverDetails) {
      console.log(driverDetails, "driverDetails");
      console.log(
        driverDetails?.isPrimaryDriver,
        "driverDetails?.isPrimaryDriver"
      );
      value = driverDetails?.isPrimaryDriver ? "Primary" : "Secondary";
    }
    return (
      <tr key={i}>
        <td>
          <P>{element.name}</P>
        </td>
        <td>
          <P>{value}</P>
        </td>
      </tr>
    );
  });
  return (
    <Card className="trip-details">
      <CardBody>
        <Row>
          {/* <Image
            attrImage={{
              className: "img-100 h-100 rounded-circle",
              alt: "",
              src: `${require("../../assets/images/booking/customer.png")}`,
            }}
          /> */}
          <div className="img-100 h-100 rounded-circle profile-image-box">
            <div className="profile-image">{profileImage}</div>
          </div>
          <div className="table-responsive">
            <table className="booking-list-table">
              <thead>
                <tr></tr>
              </thead>
              <tbody>{tableData}</tbody>
            </table>
          </div>
        </Row>
      </CardBody>
    </Card>
  );
};

export default DriverInformation;
